// import { gaWrapper } from 'helpers/analytics';
import { debugLogs } from 'utils/common';
import Cookie from '../../utils/cookies';

const jarvisTokeyvalMap = {
  business: 'Channel',
  platform: 'platform',
  section: 'SCN',
  sectionl2: 'SubSCN',
  sectionl3: 'LastSubSCN',
  templatename: 'Tmpl_SCN',
  customurl: 'pathname',
  daysIndex: 'dayIndex',
};
export function setSubSecNavFrmUrl(url, IND = 1) {
  const isShowPage = url.includes('.cms');
  const pathList = url.split('/');
  const subSecsMap = {};
  if (pathList.length === 0) {
    return null;
  }
  let count = 1;
  const skipIndex = [];
  const lastIndex = pathList.length;
  if (isShowPage) {
    for (let i = lastIndex - 3; i < lastIndex; i += 1) {
      skipIndex.push(i);
    }
  }
  pathList.forEach((path, index) => {
    if (index > IND + 1 && !skipIndex.includes(index)) {
      switch (true) {
        case index === IND + 2:
          subSecsMap.SCN = path;
          break;
        case index === IND + 3:
          subSecsMap.SubSCN = path;
          break;
        case index === IND + 4:
          subSecsMap.LastSubSCN = path;
          break;
        case index > IND + 4:
          subSecsMap[`${'LastSubSCN_Child_'}${count}`] = path;
          count += 1;
          break;
        default:
          break;
      }
    }
  });

  // console.log(pathList);
  return subSecsMap;
}
export function getAtfFanAdCode() {
  return {
    size: '300x250',
    placementId: '327541940615355_2433755636660631',
  };
}
export function getFbnFanAdCode() {
  return {
    size: '320x50',
    placementId: '327541940615355_2433757486660446',
  };
}

export function setAdsConfig(data) {
  if (data && typeof data === 'object' && typeof window === 'object') {
    window.Times = window.Times || {};
    window.Times.adsConfig = window.Times.adsConfig || {};
    window.Times.adsConfig.SubSCN = data.subSection || '';
  }
}

export function checkGeoHandling(cb) {
  if (window.TimesGDPR && window.TimesGDPR.common.consentModule.gdprCallback) {
    window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
      if (dataObj) {
        const geoinfo = { ...dataObj, userCountry: Cookie.get('geo_country') };
        if (typeof cb === 'function') {
          cb(geoinfo);
        }
      }
    });
  }
}

export function isMrecAds(adData = {}) {
  if (
    (adData.adType === 'dfp' || !adData.isCTN) &&
    typeof adData.adCode === 'string' &&
    adData.adCode
      .substring(adData.adCode.length - 4, adData.adCode.length)
      .toLowerCase() === 'mrec'
  ) {
    return true;
  }
  return false;
}

export function getAdSlotForDiv(divId) {
  if (
    typeof window !== 'undefined' &&
    typeof window.googletag !== 'undefined'
  ) {
    return window.googletag
      .pubads()
      .getSlots()
      .filter(
        // return true if the ID of the slot object is divId of adDiv
        slot => divId === slot.getSlotElementId(),
      );
  }
  return null;
}

export function getKeyvaluesNav(navObj, contentUrl, IND) {
  const resObj = {};
  try {
    const navObjLen = navObj && Object.keys(navObj).length;
    if (contentUrl && !navObjLen) {
      // in case navObj not available
      return setSubSecNavFrmUrl(contentUrl, IND);
    }
    const subSecsMap = {
      subsecname1: 'SCN',
      subsecname2: 'SubSCN',
      subsecname3: 'LastSubSCN',
    };
    Object.keys(navObj).forEach(key => {
      const subsec = navObj[key];
      const index = parseInt(key.charAt(key.length - 1), 10);
      if (index > 0) {
        const innerKey = `subsecname${index}`;
        const adTargetKey =
          subSecsMap[innerKey] || `${'LastSubSCN_Child_'}${index - 3}`;
        const adTargetVal = subsec[innerKey];
        if (adTargetKey && adTargetVal) {
          resObj[adTargetKey] = adTargetVal.toLowerCase();
        }
      }
    });
    if (contentUrl && !resObj?.SCN) {
      return setSubSecNavFrmUrl(contentUrl, IND);
    }
    debugLogs('resobj', resObj);
  } catch (e) {
    debugLogs('error', e);
  }
  return resObj;
}

export const getAdsNavSubsecsForVideoshow = navsubsecs => {
  if (navsubsecs) {
    const result = {};

    if (navsubsecs.subsec1?.subsecname1 === 'Videos') {
      // Skip subsec1 and start from subsec2
      if (navsubsecs.subsec2?.subsecname2) {
        result.subsec1 = {
          subsecname1: navsubsecs.subsec2.subsecname2.replace(/-/g, ' '),
          subsecmsid1: navsubsecs.subsec2.subsecmsid2,
        };
      }
      if (navsubsecs.subsec3?.subsecname3) {
        result.subsec2 = {
          subsecname2: navsubsecs.subsec3.subsecname3,
          subsecmsid2: navsubsecs.subsec3.subsecmsid3,
        };
      }
      if (navsubsecs.subsec4?.subsecname4 && navsubsecs.subsec4?.subsecmsid4) {
        result.subsec3 = {
          subsecname3: navsubsecs.subsec4.subsecname4,
          subsecmsid3: navsubsecs.subsec4.subsecmsid4,
        };
      }
      return result;
    }
  }
  return navsubsecs;
};

/* ATF sticky logic start */

export const observeResizeChange = (elem, callback) => {
  const resizeObserver = new ResizeObserver(entries => {
    try {
      resizeObserver.observe(elem);
      callback(entries, resizeObserver);
    } catch (e) {
      //console.log(e);
    }
  });
  resizeObserver.observe(elem);
};

export function atfStickyCloseBtnHandler() {
  if (
    typeof window !== 'undefined' &&
    typeof window._dfpObj === 'object' &&
    typeof window._dfpObj?.atfStickyCloseBtnHandler === 'function'
  ) {
    window._dfpObj.atfStickyCloseBtnHandler();
  }
}

export function getUniqueKeywords(seokws, kwrds) {
  if (typeof seokws === 'string' && typeof kwrds === 'string') {
    const kwsarr1 = seokws ? seokws.split(',') : [];
    const kwsarr2 = kwrds ? kwrds.split(',') : [];
    const setKws = new Set([...kwsarr1, ...kwsarr2]);
    return Array.from(setKws).join(',');
  }
  return seokws || kwrds;
}
// check if ad is active from the jarvis portal
export function checkJarvisIsAdActive(confName) {
  if (
    typeof window !== 'undefined' &&
    typeof window.adsconfig === 'object' &&
    typeof window.checkJarvisIsAdActive === 'function' &&
    window.adsconfig[confName] &&
    window.checkJarvisIsAdActive(window.adsconfig[confName]) === 1
  ) {
    return window.adsconfig[confName];
  }
  return null;
}
// Article show CPD
export function isLatestArticle(storydl) {
  const today = new Date();
  today.setDate(today.getDate() - 9);
  const twodaysback = today.setHours(0, 0, 0);
  const createdDate = parseInt(storydl, 10);
  // article should be created in last 10 days
  if (twodaysback < createdDate) {
    return 1;
  }
  return 0;
}
const removeSplchracterFromStr = str => {
  try {
    if (typeof str === 'string') {
      return str.replace(/[^a-zA-Z0-9\/]/g, '').toLowerCase();
    }
    return str;
  } catch (e) {
    debugLogs('removeSplchracterFromStr', e);
    return str;
  }
};
export const isValidProperty = (jarvisProp, pageProp) => {
  try {
    jarvisProp = Array.isArray(jarvisProp) ? jarvisProp : [jarvisProp];
    const excludeList = [];
    const includeList = [];
    jarvisProp.forEach(list => {
      list = list || '';
      list = list.toLowerCase();
      if (list.indexOf('ex-') === 0) {
        let ll = list.split('ex-')[1];
        ll = removeSplchracterFromStr(ll);
        excludeList.push(ll);
      } else {
        const ll = removeSplchracterFromStr(list);
        includeList.push(ll);
      }
    });
    pageProp = removeSplchracterFromStr(pageProp);
    if (jarvisProp.length > 0) {
      if (excludeList.length && excludeList.indexOf(pageProp) > -1) {
        return 0;
      }
      if (
        jarvisProp.indexOf('all') === -1 &&
        includeList.length &&
        includeList.indexOf(pageProp) === -1
      ) {
        return 0;
      }
    }
    return 1;
  } catch (e) {
    debugLogs('isValidProperty', e);
    return 0;
  }
};

export function isCurrentAdActiveSS(jarvisObj, pageConfig, isNewAs) {
  try {
    const { isWapView, dl, SCN } = pageConfig;
    jarvisObj = { ...jarvisObj };
    if (!pageConfig.platform) {
      pageConfig.platform = isWapView ? 'mweb' : 'web';
    }
    jarvisObj.isAdActive = 0;
    jarvisObj.scn = SCN;
    // for debug purpose
    // const pageConf = { isWapView, Tmpl_SCN, SCN, business, articledl };
    // in case of latest AS
    if (dl) {
      jarvisObj.dl = dl;
      if (!isNewAs) {
        jarvisObj.failDueTo = 'not latest article';
        return jarvisObj;
      }
    }
    const keys = Object.keys(jarvisTokeyvalMap) || [];
    for (let index = 0; index < keys.length; index += 1) {
      const jarvisKey = keys[index];
      const pageKey = jarvisTokeyvalMap[jarvisKey];
      const jarvisprop = jarvisObj[jarvisKey];
      if (jarvisprop) {
        const pageProp = pageConfig[pageKey];
        const result = isValidProperty(jarvisprop, pageProp);
        if (result === 0) {
          jarvisObj.failDueTo = `jarvisKey-${jarvisKey}|pageKey-${pageKey}|pageProp-${pageProp}|jarvisprop-${jarvisprop}`;
          return jarvisObj;
        }
      }
    }
    if (jarvisObj.jmweb_setting && isWapView) {
      jarvisObj = {
        ...jarvisObj,
        ...jarvisObj.jmweb_setting,
      };
    }
    jarvisObj.jmweb_setting = null;
    jarvisObj.isAdActive = 1;
    return jarvisObj;
  } catch (e) {
    debugLogs('isCurrentAdActiveSS', e);
    return jarvisObj;
  }
}
export function checkJarvisAdsConfigForSS(config) {
  try {
    const { dl } = config;

    // in case of latest AS
    let isNewAs = 1;
    if (dl) {
      isNewAs = isLatestArticle(dl);
    }
    // Ads which req only height for CLS
    const caimpaigns = Object.keys(config.jarvisConfig);
    caimpaigns.forEach(caimpaign => {
      const currentCaimpaign = config.jarvisConfig[caimpaign];
      if (currentCaimpaign?.checkpageconfig) {
        config.jarvisConfig[caimpaign] = isCurrentAdActiveSS(
          currentCaimpaign,
          config,
          isNewAs,
        );
      }
    });
    const sharableObj = {};
    if (isNewAs) {
      sharableObj.isNewAs = isNewAs;
    }
    if (config.Hyp1 || config.specialId) {
      sharableObj.specialId = config.Hyp1 || config.specialId;
    }
    config.jarvisConfig.pageConfig = sharableObj;

    return { ...config.jarvisConfig };
  } catch (e) {
    debugLogs('isCurrentAdActiveSS', e);
    return {};
  }
}

export const getAdsTargetingObj = (config, navKeyObj) => {
  try {
    const metaKeywords = getUniqueKeywords(config.newsKws, config.kws);
    const targetkeyValues = {
      Tmpl_SCN: config.Tmpl_SCN,
      Channel: config.Channel,
      Meta_Keywords: metaKeywords,
      Content_URL: config.contentURL,
      ...navKeyObj,
    };
    if (config.articleId) {
      targetkeyValues.Article_ID = config.articleId;
    }
    if (config.specialId) {
      targetkeyValues.Hyp1 = config.specialId;
    }
    return targetkeyValues;
  } catch (e) {
    debugLogs('isValidProperty', e);
    return {};
  }
};

export const processAdsCaimpaigns = templateConfig => {
  try {
    const { navSubsecs, pathname, isMobile } = templateConfig;
    const navObj = getKeyvaluesNav(navSubsecs, pathname, -1);
    const keyValueObj = getAdsTargetingObj(templateConfig, navObj);
    let newCaimpaignConfig = null;
    if (typeof window === 'undefined') {
      const navs = Object.keys(navObj);
      navs.forEach(key => {
        templateConfig[key] = navObj[key];
      });
      templateConfig.platform = isMobile ? 'mweb' : 'web';
      // REVENUE CAIMPAIGN CHECK CONFIG IS ACTIVE OR NOT
      newCaimpaignConfig = checkJarvisAdsConfigForSS(templateConfig);
    }
    return { keyValueObj, newCaimpaignConfig };
  } catch (e) {
    debugLogs('isValidProperty', e);
    return {};
  }
};

export const newGamSection = targetObj => {
  const { SCN = '' } = targetObj || {};
  const skipSection = ['international', 'business', 'world'];
  return skipSection.includes(SCN);
};

const updateCounters = (sections, key, counters) => {
  try {
    const ignoreList = ['taboola', 'ctn'];
    let lastAdIndex = -1;
    if (sections?.length) {
      sections.forEach((e, i) => {
        if (!e) return;
        const isNested = e.items?.length === 1 && e.items[0]?.tn === 'ad';
        const isAd =
          e.tn === 'ad' &&
          !e.jname &&
          !ignoreList.includes(e.adType) &&
          !isNested;

        if (isAd) {
          const gap = lastAdIndex >= 0 ? i - lastAdIndex : 2;
          if (gap > 1) {
            e.jname = key + (counters[key] || '');
            e.groupName = key === 'mrec' ? 'mrecs' : 'midAds';
            counters[key] = (counters[key] || 0) + 1;
          } else {
            e.tn = 'skipAd';
          }
          lastAdIndex = i;
        }
        if (e.items?.length) {
          updateCounters(e.items, 'mrec', counters);
        }
        if (e.inserts?.length) {
          const insertedItem =
            e.inserts?.length === 1 && Array.isArray(e.inserts[0])
              ? e.inserts[0]
              : e.inserts;
          updateCounters(insertedItem, 'mrec', counters);
        }
      });
    }
  } catch (e) {
    //
  }
};

export const updateAdCounter = (data, isMobile) => {
  const { sections, sectionitems } = data || {};
  const list = sections || sectionitems;
  const counters = {
    mid: 0,
    mrec: 0,
  };
  const key = isMobile ? 'mrec' : 'mid';
  updateCounters(list, key, counters);
};
